import { ItfCompareBtn, ItfCompareChild, ItfCompareColor, ItfCompareData, ItfCompareSpec, ItfCompareLink, ItfCompareItem } from './type';

export const defaultBtn: ItfCompareBtn = {
    ...({} as ItfCompareBtn),
    type: 'fill',
    text: '',
    url: '',
};

export const defaultColor: ItfCompareColor = {
    ...({} as ItfCompareColor),
    btns: [defaultBtn],
    color: 'black',
    img: '',
    label: '',
};

export const defaultSpec: ItfCompareSpec = {
    ...({} as ItfCompareSpec),
    name: '',
    text: '',
};

export const defaultLink: ItfCompareLink = {
    ...({} as ItfCompareLink),
    text: '',
    url: '',
};

export const defaultItem: ItfCompareItem = {
    ...({} as ItfCompareItem),
    label: '',
    name: '',
    text: '',
    type: 'normal',
    img: '',
    btns: [defaultBtn],
    colors: [defaultColor],
    specs: [defaultSpec],
};

export const defaultChild: ItfCompareChild = {
    ...({} as ItfCompareChild),
    tab: '',
    items: [defaultItem],
    links: [defaultLink],
};

export const configData: ItfCompareData = {
    ...({} as ItfCompareData),
    theme: 'white',
    title: '',
    titleColor: 'black',
    children: [defaultChild],
};
